import {
  adjustForMidnightPeriod,
  LenientDatePeriod,
  TimeOfDay,
} from "@greeter/date";
import { addDays, set } from "date-fns";

export type GetServiceDayPeriodArgs = {
  bookingArrivalTime: Date;
  anchorTimeOfDay?: TimeOfDay;
};

/**
 * The service day is the period from 6 in the morning to 6
 * in the morning the next day. Defaults to 6 in the morning.
 * Can be changed with the `anchorTimeOfDay`
 *
 * This is a wide net on purpose to catch all locked and booked
 * tables in the period.
 *
 * This is useful for when the strategy is one-booking-per-opening-hours.
 */
export function getServiceDayPeriod({
  bookingArrivalTime,
  anchorTimeOfDay = TimeOfDay.parse("06:00"),
}: GetServiceDayPeriodArgs) {
  const start = adjustForMidnightPeriod(bookingArrivalTime);
  return new LenientDatePeriod({
    from: set(start, {
      hours: anchorTimeOfDay.hours,
      minutes: anchorTimeOfDay.minutes,
      seconds: anchorTimeOfDay.seconds,
    }),
    to: set(addDays(start, 1), {
      hours: anchorTimeOfDay.hours,
      minutes: anchorTimeOfDay.minutes,
      seconds: anchorTimeOfDay.seconds,
    }),
  });
}
